module.exports = __webpack_public_path__ + "static/img/1.f6bc8f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/1.png
// module id = Txl5
// module chunks = 2